/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerTranslation } from "../../../../../../shared/context/PlayerTranslationContext";
import SettingsIcon from "../../../../../../shared/icons/player/Settings.svg";
import { usePlayerSettings } from "../../../../../BasePlayer";
import { usePlayerCastState } from "../../../../../Controller";
import { useOverlayState } from "../../../../../Overlay";
import { DropdownMenu, ToggleButton } from "../../../../Base";

import { AudioSection } from "./AudioSection";
import { AvailableSectionProvider } from "./AvailableSectionContext";
import { MainSection } from "./MainSection";
import { PlaybackRateSection } from "./PlaybackRateSection";
import { QualitySection } from "./QualitySection";
import { SubtitleSection } from "./SubtitleSection";

export const SettingsToggleButton = () => {
  const { isCastConnected } = usePlayerCastState();
  const { toggleSettings } = useOverlayState();

  const {
    ui: { tooltipOffset },
  } = usePlayerSettings();

  const { t } = usePlayerTranslation();

  if (isCastConnected) {
    return null;
  }

  return (
    <ToggleButton
      variant="secondary"
      icon={<SettingsIcon aria-hidden="true" focusable="false" />}
      tooltip={t("PLAYER_TOOLTIP_SETTINGS")}
      tooltipOffset={tooltipOffset}
      onVisibilityChange={toggleSettings}
      iconOnly
    >
      <DropdownMenu defaultSection="settings">
        <AvailableSectionProvider initialAvailableSections={["quality"]}>
          <MainSection />
          <QualitySection />
          <PlaybackRateSection />
          <AudioSection />
          <SubtitleSection />
        </AvailableSectionProvider>
      </DropdownMenu>
    </ToggleButton>
  );
};
